export default __webpack_public_path__ + "static/media/user-stat-icon.d619d088.svg";